import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { CouponItem, ResultAlert, MktEmpty, PageLoading } from '@cps'
import { memberMobx, activityMobx, memberCardMobx } from '@mobxStore'
import ActivityApi from '@api/activity.api'
import { modalLayer, useHistoryNew, toast, getPlatform } from '@utils'
import mktController from 'controllers/mktController'
import Loading from '../components/loading'
import { each, keyBy, find, isEmpty } from '@dt/fe-utils/dist/lodash'
import i18n from 'i18next'
import { Tiger, FixBackHeader } from 'pages/mkt/components'
import { ActivityInfo } from './ActivityInfo'
import MoreTimesModal from './MoreTimesModal'
import codeSendBgImg from '@img/mkt/codeSendBg.jpeg'
import './index.scss'

const { isWeixinMiniProgram } = getPlatform()

interface IProps extends IPage, RouteComponentProps { }

let couponListMap: any = {}
let startBool: boolean = false

const TigerLuckDraw: FC<IProps> = ({ match }) => {
  const { activityId } = match.params as any
  const history = useHistoryNew()
  const [activeStatus, setActiveStatus] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(true)
  const [startType, setStartType] = useState<boolean>(false)
  const [drawNum, setDrawNum] = useState<number>(0)
  const [activeInfo, setActiveInfo] = useState<any>({})
  const [prizeInfo, setPrizeInfo] = useState<any>({})
  const [partInNum, setPartInNum] = useState<number>(0)
  const [isOverUpLimit, setIsOverUpLimit] = useState<boolean>(false)
  const [activeResult, setActiveResult] = useState<string>('')
  const [prizeNum, setPrizeNum] = useState<number>(0)
  const [prizeSettings, setPrizeSettings] = useState<string[]>([])
  const [noHasRechargeCard, setNoHasRechargeCard] = useState<boolean>(false)
  const { isLogin, memberInfo } = memberMobx
  const { getActiveDetail } = activityMobx
  // Component Event
  const goBack = () => {
    mktController.goBack(history)
  }
  const getDraw = () => {
    if (startBool) return
    if (!activeStatus) {
      toast({ message: i18n.t('mkt.market.eventIsOver') })
      return
    }
    // if (partInNum === 0 && (prizeSettings.length === 0 || isOverUpLimit)) return
    mktController.checkLogin(history).then(async () => {
      if (partInNum === 0 && (prizeSettings.length === 0 || isOverUpLimit)) return
      if (partInNum > 0) {
        startBool = true
        ActivityApi.getStartPrize({ brandId: memberMobx.brandId, activityId: activityId }).then((res: any) => {
          setDrawNum(drawNum + 1)
          setPartInNum(partInNum - 1)
          setActiveResult(res.status)
          if (res.status === 'success') {
            setPrizeInfo(res.prize)
            const couponIds: any = []
            each(res.prize.coupons, (item: any) => {
              couponIds.push(item.couponId)
            })
            ActivityApi.getCouponsList({ couponIds: couponIds }).then((coupon: any) => {
              if (coupon?.length > 0) {
                couponListMap = keyBy(coupon, 'couponId')
              } else {
                couponListMap = {}
              }
            })
          }
          setStartType(true)
        }).catch((error: any) => {
          startBool = false
          if (error.code === 4023) {
            // 没有抽奖机会
            showEnd(i18n.t('mkt.activity.noPartInNum'))
            setPartInNum(0)
          }
          if (error.code === 4004) {
            // 活动不存在
            toast({ message: i18n.t('mkt.market.activityNotExist') })
            setActiveStatus(false)
          }
          if (error.code === 4024) {
            // 活动结束
            toast({ message: i18n.t('mkt.market.eventIsOver') })
            setActiveStatus(false)
          }
        })
      } else {
        if (prizeSettings.length === 1) {
          if (prizeSettings[0] === 'inviteGive') goShare()
          if (prizeSettings[0] === 'giftCardRechargeGive') {
            history.push('/allGiftCard', { giftCardIds: activeInfo.extra?.prizeSettings?.giftCardRechargeGive.giftcardIds })
          }
          if (prizeSettings[0] === 'memberCardRechargeGive') {
            if (noHasRechargeCard) return toast({ message: i18n.t('mkt.activity.noHasRechargeCard') })
            history.push('/activity/card', { cardIds: activeInfo.extra?.prizeSettings?.memberCardRechargeGive.cardIds, isAllMember: !!activeInfo.extra?.prizeSettings?.memberCardRechargeGive.isAllMember })
            // modalLayer(ActRelateCardModal, { cardIds: activeInfo.extra?.prizeSettings?.memberCardRechargeGive.cardIds }).then((url: any) => {
            //   history.push(url)
            // }).catch(() => {})
          }
        } else {
          showMoreTimesModal()
        }
      }
    })
  }
  const showMoreTimesModal = () => {
    modalLayer(MoreTimesModal, {
      title: i18n.t('mkt.activity.getNumber'),
      des: i18n.t('mkt.activity.chooseOneGet'),
      children: (
        <>
          {
            prizeSettings.includes('inviteGive') &&
              <div
                className='get-number-btn'
                onClick={() => { modalLayer.closeAll(); goShare() }}
                dangerouslySetInnerHTML={{ __html: i18n.t('mkt.activity.inviteSomeGet', { num: `<span style="color: #E50E2B" >${activeInfo.extra?.prizeSettings?.inviteGive.inviteNum}</span>` }) }}
              >
              </div>
          }
          {
            prizeSettings.includes('giftCardRechargeGive') &&
              <div className='get-number-btn' onClick={() => history.push('/allGiftCard', { giftCardIds: activeInfo.extra?.prizeSettings?.giftCardRechargeGive.giftcardIds })}>{i18n.t('mkt.activity.chooseGiftGet')}</div>
          }
          {
            prizeSettings.includes('memberCardRechargeGive') &&
              <div
                className='get-number-btn'
                onClick={async () => {
                  if (noHasRechargeCard) return toast({ message: i18n.t('mkt.activity.noHasRechargeCard') })
                  history.push('/activity/card', { cardIds: activeInfo.extra?.prizeSettings?.memberCardRechargeGive.cardIds, isAllMember: !!activeInfo.extra?.prizeSettings?.memberCardRechargeGive.isAllMember })
                  // modalLayer(ActRelateCardModal, { cardIds: activeInfo.extra?.prizeSettings?.memberCardRechargeGive.cardIds }).then((url: any) => {
                  //   history.push(url)
                  // }).catch(() => {})
                }}
              >
                {i18n.t('mkt.activity.chooseMemberGet')}
              </div>
          }
        </>
      )
    })
  }
  const showResult = () => {
    setStartType(false)
    startBool = false
    if (activeResult === 'success') {
      showSucc()
    } else {
      showEnd(i18n.t('mkt.activity.noPrize'))
    }
  }
  const showSucc = () => {
    modalLayer(ResultAlert, {
      title: prizeInfo.name,
      des: i18n.t('mkt.activity.couponTip'),
      btnTitle: i18n.t('mkt.common.toUse'),
      children: prizeInfo && prizeInfo.coupons.map((item: any, index: number) => {
        const hasItem: any = couponListMap[item.couponId]
        return hasItem && (
          <div className='coupon-block' key={`${index}-${item.couponId}`}>
            <CouponItem type='use' couponInfo={hasItem} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
          </div>)
      })
    }).then(() => {
      history.replace('/menu')
    }, () => { })
  }
  const showEnd = (title: string) => {
    modalLayer(ResultAlert, {
      btnTitle: partInNum > 0 ? i18n.t('mkt.activity.moreTime') : activeInfo?.extra.invitationType ? i18n.t('mkt.activity.getShare') : i18n.t('mkt.activity.share'),
      btnDes: partInNum > 0 ? i18n.t('mkt.activity.changeNum', { num: partInNum }) : activeInfo?.extra.invitationType ? i18n.t('mkt.activity.inviteNum', { num: activeInfo.extra.invitationNum }) : '',
      children: (
        <>
          <i className='iconfont icon-title icon-sad'></i>
          <div className='end-title'>{title}</div>
        </>
      )
    }).then(() => {
      if (partInNum > 0) {
        getDraw()
      } else {
        goShare()
      }
    }, () => { })
  }
  const getTimes = () => {
    showMoreTimesModal()
  }
  const goShare = () => {
    mktController.checkLogin(history).then(() => {
      const shareInfo: any = {
        memberId: memberInfo.memberId || 0,
        activityId: activityId
      }
      const url = `${location.href}&shareInfo=${encodeURIComponent(JSON.stringify(shareInfo))}`
      mktController.shareUrl(url)
    })
  }
  const goPrize = () => {
    history.push(`/luckyDraw/prize/${activityId}`)
  }
  const goRecord = () => {
    mktController.checkLogin(history).then(() => {
      history.push(`/luckyDraw/record/${activityId}`)
    })
  }
  // Data Method
  const getActiveData = async () => {
    setLoading(true)
    try {
      await getActiveDetail(activityId).then((res: any) => {
        if (res) {
          setActiveInfo(res)
          if (res?.isOver) setActiveStatus(false)
        } else {
          setActiveStatus(false)
        }
      })
    } catch (error) {
    }
    setLoading(false)
  }

  const getRule = () => {
    modalLayer(ActivityInfo, { activeInfo, goPrize, goRecord, prizeNum }).catch(() => { })
  }

  const getPrizeTimes = () => {
    ActivityApi.getPrizeTimes({ brandId: memberMobx.brandId, activityId: activityId }).then((res: any) => {
      setPartInNum(res.allChanceNum || 0)
      setIsOverUpLimit(res.overUpperLimit)
    })
  }

  // 抽奖按钮文案展示
  const drawBtnText = () => {
    let btnText = ''
    let btnDesText = ''
    if (partInNum > 0) {
      btnText = drawNum > 0 ? i18n.t('mkt.activity.moreTime') : i18n.t('mkt.activity.startDraw')
      btnDesText = i18n.t('mkt.activity.drawNum', { label: partInNum })
    } else {
      if (prizeSettings.length === 0 || isOverUpLimit) {
        btnText = i18n.t('mkt.activity.overUpLimit')
        btnDesText = null
      } else {
        if (prizeSettings.length === 1) {
          if (prizeSettings[0] === 'inviteGive') {
            btnText = i18n.t('mkt.activity.inviteGet', { num: activeInfo.extra.prizeSettings.inviteGive.inviteNum })
          } else if (prizeSettings[0] === 'giftCardRechargeGive') {
            btnText = i18n.t('mkt.activity.giftCardRechargeGet')
          } else {
            btnText = i18n.t('mkt.activity.memberCardRechargeGet')
          }
        } else {
          btnText = i18n.t('mkt.activity.getMoreNum')
        }
        btnDesText = i18n.t('mkt.activity.noPartInNum')
      }
    }
    return { btnText, btnDesText }
  }
  // Component Effect
  useIonViewWillEnter(() => {
    getActiveData()
    if (memberMobx.isLogin && memberMobx.memberInfo.type === 'member') {
      getPrizeTimes()
    }
  })

  useEffect(() => {
    ActivityApi.getPrizes({ brandId: memberMobx.brandId, activityId: activityId }).then((res: any) => {
      if (res.length > 0) {
        setPrizeNum(res.length)
      }
    })
  }, [prizeInfo])

  useEffect(() => {
    if (Object.keys(activeInfo).length !== 0 && memberMobx.isLogin && memberMobx.memberInfo.type === 'member') {
      const shareInfo: any = {
        memberId: memberInfo.memberId || 0,
        activityId: activityId
      }
      let url = `${location.origin}/luckyDraw/detail/${activityId}?ct=brand&b=${Config.BRANDID}&shareInfo=${encodeURIComponent(JSON.stringify(shareInfo))}`
      if (isWeixinMiniProgram) {
        url = `/pages/launch/index?jumpH5Page=${encodeURIComponent(url)}&shareInfo=${encodeURIComponent(JSON.stringify(shareInfo))}`
      }
      const _prizeSettings: string[] = []
      if (activeInfo.extra.prizeSettings) {
        Object.keys(activeInfo.extra.prizeSettings).forEach((key) => {
          if (activeInfo.extra?.prizeSettings[key] && ['giftCardRechargeGive', 'memberCardRechargeGive', 'inviteGive'].includes(key)) _prizeSettings.push(key)
        })
      }
      setPrizeSettings(_prizeSettings)
      mktController.initShareData({
        url: url,
        title: activeInfo.activityName,
        des: activeInfo.extra?.copywriting || i18n.t('mkt.activity.entrance'),
        img: activeInfo.extra?.interfaceDisplay || '',
      })
    }
  }, [activeInfo, memberMobx.isLogin, memberMobx.memberInfo])
  useEffect(() => {
    const getCardArr: any[] = memberCardMobx.cardList.filter((item: any) => {
      const hasItem: any = find(memberMobx.cardList, (m: any) => m.cardId === item.cardId)
      return !hasItem
    })
    const memberCardIds = activeInfo.extra?.prizeSettings?.memberCardRechargeGive?.cardIds || []
    if (prizeSettings.includes('memberCardRechargeGive') && (memberCardIds && memberCardIds.length !== 0)) {
      const flag1 = memberMobx.cardList.every((item: any) => !(memberCardIds.includes(item.cardId) || (item.card && memberCardIds.includes(item.card.cardId))))
      const flag2 = getCardArr.every((item: any) => !(memberCardIds.includes(item.cardId) || (item.card && memberCardIds.includes(item.card.cardId))))
      if (flag1 && flag2) {
        // 是否有可充值以及可购买会员卡
        setNoHasRechargeCard(true)
      }
    }
  }, [memberCardMobx.cardList, memberMobx.cardList, prizeSettings])
  useEffect(() => {
    // 充值获取机会的均为实体卡
    if (prizeSettings.includes('giftCardRechargeGive') && !activeInfo.extra?.prizeSettings?.giftCardRechargeGive.isAllMember) {
      const _prizeSettings = [...prizeSettings]
      const isPhysical = (activeInfo.extra?.prizeSettings?.giftCardRechargeGive.giftcardIds || []).some((id: any) => !!memberMobx.giftCardListMap[id])
      if (!isPhysical) {
        _prizeSettings.splice(prizeSettings.indexOf('giftCardRechargeGive'), 1)
        setPrizeSettings(_prizeSettings)
      }
    }
  }, [memberMobx.giftCardListMap, prizeSettings])
  return (
    <IonPage className='active-tiger-page'>
      <FixBackHeader text={i18n.t('mkt.market.marketDetail')} onClick={getRule} />
      <IonContent className='page-content'>
        <div className='page-body'>
          <div className='img-block'><img className='activity-img' src={!isEmpty(activeInfo) ? (activeInfo.extra?.interfaceDisplay || codeSendBgImg) : ''} /></div>
          {/* <img className='activity-img' src={activeInfo.extra?.interfaceDisplay} /> */}
          {
            activeStatus ? (
              <div className='activity-info'>
                <div className='luck-draw'>
                  <Tiger
                    startType={startType}
                    result={activeResult}
                    onStop={showResult}
                  >
                  </Tiger>
                  {
                    isLogin && memberInfo.type === 'member' ? (
                      (
                        <div
                          className={`draw-btn ${partInNum === 0 && !startType && (prizeSettings.length === 0 || isOverUpLimit) ? 'disable' : ''}`}
                          onClick={getDraw}
                        >
                          {
                            startType ? (
                              <Loading />
                            ) : (
                              <div>
                                <div>{drawBtnText().btnText}</div>
                                {drawBtnText().btnDesText && <div className='left-num'>{drawBtnText().btnDesText}</div>}
                                {/* <div className='left-num'>{partInNum > 0 ? i18n.t('mkt.activity.drawNum', { label: partInNum }) : i18n.t('mkt.activity.noPartInNum')}</div> */}
                              </div>
                            )
                          }
                        </div>
                      )
                    ) : (
                      <div className='draw-btn' onClick={getDraw}>
                        <div>{!isLogin ? i18n.t('mkt.activity.login') : i18n.t('mkt.activity.bind')}</div>
                      </div>
                    )
                  }
                  {
                    isLogin && memberInfo.type === 'member' && (
                      <div className='prize-info'>
                        {
                          prizeNum !== 0 &&
                            <div onClick={goRecord}>
                              {i18n.t('mkt.activity.myPrize')}
                            </div>
                        }
                        {
                          prizeNum !== 0 && partInNum > 0 && prizeSettings.length > 0 && <div className='vertical-line' />
                        }
                        {
                          partInNum > 0 && prizeSettings.length > 0 &&
                            <div className='more' onClick={getTimes}>
                              {i18n.t('mkt.activity.moreNum')}
                            </div>
                        }
                      </div>
                    )
                  }
                </div>
              </div>
            ) : (
              <div className='activity-end'>
                <MktEmpty type='end' text={activeInfo?.activityId ? i18n.t('mkt.market.eventIsOver') : i18n.t('mkt.market.activityNotExist')}></MktEmpty>
              </div>
            )
          }
          {
            loading && <PageLoading />
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(TigerLuckDraw)
